import { baseApi } from './base';
import type {
  Timesheet,
  CreateTimesheetRequest,
  UpdateTimesheetRequest,
  StartTimesheetRequest,
  StopTimesheetRequest,
  PauseTimesheetRequest
} from '@/types/timesheet';

export const timesheetService = {
  async getTimesheets(params: { limit: number; offset: number; search?: string; lawsuit?: string; }): Promise<{ results: Timesheet[], count: number }> {
    const queryParams: Record<string, string> = {
      limit: params.limit.toString(),
      offset: params.offset.toString(),
    };

    if (params.search) {
      queryParams.search = params.search;
    }

    if (params.lawsuit) {
      queryParams.lawsuit = params.lawsuit;
    }

    const query = new URLSearchParams(queryParams).toString();
    return baseApi.request<{ results: Timesheet[], count: number }>(`/timesheets/?${query}`);
  },

  async createTimesheet(data: CreateTimesheetRequest): Promise<Timesheet> {
    return baseApi.request<Timesheet>('/timesheets/', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async startTimesheet(data: StartTimesheetRequest = {}): Promise<Timesheet> {
    return baseApi.request<Timesheet>('/timesheets/start/', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async getActiveTimesheet(): Promise<Timesheet | null> {
    const response = await baseApi.request<any>('/timesheets/active/');
    if (Array.isArray(response)) {
      if (response.length === 0) return null;
      return response[0] as Timesheet;
    }
    if (response && typeof response === 'object' && Object.keys(response).length === 0) {
      return null;
    }
    return response as Timesheet;
  },

  async stopTimesheet(id: string, data: StopTimesheetRequest): Promise<Timesheet> {
    return baseApi.request<Timesheet>(`/timesheets/${id}/stop/`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async pauseTimesheet(id: string, data: PauseTimesheetRequest): Promise<Timesheet> {
    return baseApi.request<Timesheet>(`/timesheets/${id}/pause/`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async resumeTimesheet(id: string): Promise<Timesheet> {
    return baseApi.request<Timesheet>(`/timesheets/${id}/resume/`, {
      method: 'POST',
    });
  },

  async updateTimesheet(id: string, data: UpdateTimesheetRequest): Promise<Timesheet> {
    return baseApi.request<Timesheet>(`/timesheets/${id}/`, {
      method: 'PATCH', // Using PATCH as it's partial updates
      body: JSON.stringify(data),
    });
  },

  async deleteTimesheet(id: string): Promise<void> {
    return baseApi.request<void>(`/timesheets/${id}/`, {
      method: 'DELETE',
    });
  },

  async discardTimesheet(id: string): Promise<void> {
    return baseApi.request<void>(`/timesheets/${id}/discard/`, {
      method: 'DELETE',
    });
  },
};